import { maxBy } from 'lodash'
import moment from 'moment'

import { ProjectStage } from '@/schemas'

export * from './resource-evaluation.container'
export * from './resource-evaluation-form.component'

export const getProjectDelay = (stages: ProjectStage[]) => {
  const latestStage = maxBy(
    stages.filter((s) => s.planEndDate),
    (s) => moment(s.planEndDate).valueOf()
  )

  const delayDays = Math.max(
    moment(latestStage?.actualEndDate || undefined).diff(latestStage?.planEndDate || undefined, 'days'),
    0
  )

  return {
    delayDays,
    latestStage,
  }
}
